<template>
  <form @submit.prevent="submit" autocomplete="off">
    <t-modal-section :title="$t('Location Details')" class="mb-3">
      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="$t('Location Name')"
            label-for="site_name"
            :state="$validateState($v.form.name)"
          >
            <b-form-input
              autofocus
              data-test-id="modal-virtual-site-name"
              :state="$validateState($v.form.name)"
              id="site_name"
              @blur="setValidationInput('name', $event.target.value)"
              :placeholder="$t('Enter site name')"
            />

            <template #invalid-feedback>
              <p
                v-if="
                  $v.form.name.$dirty &&
                  $v.form.name.required &&
                  !$v.form.name.minLength
                "
              >
                {{
                  $t("X must be at least X characters long.", {
                    field: $t("Location Name"),
                    length: $v.form.name.$params.minLength.min,
                  })
                }}
              </p>
              <p v-if="!$v.form.name.required">
                {{ $t("This is a required field.") }}
              </p>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="12" lg="6">
          <b-form-group
            :label="$t('Tag')"
            label-for="tag"
            :state="$validateState($v.form.tag)"
          >
            <b-form-input
              data-test-id="modal-virtual-tag"
              :state="$validateState($v.form.tag)"
              id="tag"
              @blur="setValidationInput('tag', $event.target.value)"
              :placeholder="$t('e.g. 4556455562232897941445tr23yu')"
            />

            <template #invalid-feedback>
              <p
                v-if="
                  $v.form.tag.$dirty &&
                  $v.form.tag.required &&
                  !$v.form.tag.minLength
                "
              >
                {{
                  $t("X must be at least X characters long.", {
                    field: $t("Tag"),
                    length: $v.form.tag.$params.minLength.min,
                  })
                }}
              </p>
              <p v-if="!$v.form.tag.required">
                {{ $t("This is a required field.") }}
              </p>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            id="policy"
            :label="this.$t('Policy')"
            label-for="policy"
          >
            <t-radio-group
              v-model="form.policy"
              :items="policyRadio"
              :dropdownOptions="policyOptions"
              :selectedItem="form.policyid"
              @change="$v.$touch()"
              @changeDropDown="onDropDownChange"
              @scrollDropDown="scrollDropDown"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </t-modal-section>
  </form>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { required, ipAddress, minLength } from "vuelidate/lib/validators";

import TModalSection from "@/components/TModalSection";

export default {
  components: {
    TModalSection,
  },
  data() {
    return {
      form: {
        policy: "None",
        name: null,
        tag: null,
        policyid: null,
      },
      currentPage: null,
      policyOptions: [],
      previousScrollPosition: null,
      dataOptions: {
        results: 10,
        page: 1,
      },
      policyRadio: [
        {
          text: this.$t("Inherited"),
          subtitle: this.$t("Inherit default policy"),
          tooltip: this.$t("Inherit default policy"),
          testID: "modal-location-virtual-policy-inherited",
          value: "None",
          checked: false,
          icon: "layer-backward",
          canCustomise: false,
          canDropDownSelect: false,
        },
        {
          text: this.$t("Specific"),
          subtitle: this.$t("Use a specific policy"),
          tooltip: this.$t("Use a specific"),
          testID: "modal-location-virtual-policy-specific",
          value: "Policy",
          checked: false,
          icon: "pencil-square",
          canCustomise: false,
          canDropDownSelect: true,
        },
      ],
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(5),
      },
      tag: {
        required,
        minLength: minLength(5),
      },
    },
  },
  watch: {
    customerPolicies() {
      this.policyOptions = [
        ...this.customerPolicies.map((p) => {
          return { value: p.id, text: p.name };
        }),
      ];
    },
  },
  methods: {
    ...mapMutations("modal", ["userAction", "showModal"]),
    ...mapActions("locations", ["createLocation"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("customerPolicies", ["fetchScrollCustomerPolicies"]),
    ipAddress,
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    onDropDownChange(item) {
      this.form.policyid = item;
      this.$v.$touch();
    },
    scrollDropDown(item) {
      const { target } = item;
      let currentScrollPosition = target.scrollTop + target.scrollHeight;

      console.log("currentScroll", currentScrollPosition);
      console.log("previous", this.previousScrollPosition);
      console.log("currentpage", this.currentPage);
      console.log("page", this.dataOptions.page);

      if (currentScrollPosition > this.previousScrollPosition) {
        if (
          Math.ceil(target.scrollTop) >=
            target.scrollHeight - target.offsetHeight &&
          this.dataOptions.page > this.currentPage
        ) {
          try {
            this.fetchScrollCustomerPolicies({
              id: this.selectedUser.id,
              ...this.dataOptions,
            });
          } catch (e) {
            console.log("e", e);
          } finally {
            this.currentPage = this.dataOptions.page;
            this.dataOptions.page++;
          }
        }
      }
      this.previousScrollPosition = currentScrollPosition;
    },
    async submit() {
      this.$v.$touch();
      /* istanbul ignore else */
      if (!this.$v.$invalid) {
        const response = await this.createLocation({
          id: this.selectedUser.id,
          type: this.modalData.type,
          body: this.form,
        });
        /* istanbul ignore else */
        if (response.code === 200) {
          this.displayToast({
            title: this.$t("Success"),
            message: this.$t("Created"),
            duration: 2000,
            variant: "success",
          });

          this.showModal(false);
        }
      }
    },
  },
  computed: {
    ...mapGetters("modal", ["modalData"]),
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("customerPolicies", ["customerPolicies"]),
  },
  created() {
    this.policyOptions = [
      ...this.customerPolicies.map((p) => {
        return { value: p.id, text: p.name };
      }),
    ];
    this.userAction(this.submit);
  },
};
</script>
